import React from 'react';

const ChatbotIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 38 38"
    style={{ enableBackground: 'new 0 0 38 38' }}
  >
    <path d="M19,37.86C8.6,37.86,0.14,29.4,0.14,19S8.6,0.14,19,0.14S37.86,8.6,37.86,19S29.4,37.86,19,37.86z M19,3.14
      C10.25,3.14,3.14,10.25,3.14,19S10.25,34.86,19,34.86S34.86,27.75,34.86,19S27.75,3.14,19,3.14z"
    />
    <path d="M28.5,12.5H9.5c-1.38,0-2.5,1.12-2.5,2.5v8c0,1.38,1.12,2.5,2.5,2.5h3v3.5c0,0.55,0.45,1,1,1
      c0.28,0,0.53-0.11,0.71-0.29L17.79,25.5H28.5c1.38,0,2.5-1.12,2.5-2.5v-8C31,13.62,29.88,12.5,28.5,12.5z M28,22H17.21
      c-0.28,0-0.53,0.11-0.71,0.29L14,24.79V23c0-0.55-0.45-1-1-1h-3v-7h18V22z"
    />
    <circle cx="14.5" cy="18.5" r="1.5" />
    <circle cx="19" cy="18.5" r="1.5" />
    <circle cx="23.5" cy="18.5" r="1.5" />
  </svg>
);

export default ChatbotIcon;
